@use 'vars';

$inset-small-menu: auto 0 0 0; // top: auto, right: 0, bottom: 0, left: 0
$max-expander-container-width: 350px;

.askiq-menu {
  &__expander-container {
    display: flex;
    flex-direction: column;
    max-width: $max-expander-container-width;
    padding: vars.$gap-xsmall vars.$padding-medium;
  }
}
